import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { DomainField } from '../domainField/DomainField';

import styles from './DomainFieldsRow.module.scss';
import Button from 'components/buttons/button';

export const DomainFieldRow = ({ fields }: any) => {
  return (
    <>
      {fields.map((alternativeDomain: any, i: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className={styles.domainFieldWrapper}>
          <DomainField name={alternativeDomain} label="Domain" className={styles.formField} />
          <Button type="button" text="Remove" onClick={() => fields.remove(i)} className={styles.addButton} />
        </div>
      ))}
      <div className={styles.wrapper}>
        <Button
          className={styles.addButton}
          type="button"
          text="Add new domain"
          icon={faPlus}
          onClick={() => fields.push('')}
        />
      </div>
    </>
  );
};
